import styled from '@emotion/styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const CalendarToolbarWrapper = styled.div<{windowWidth: number}>`
   display: flex;
   justify-content: space-between;
    padding: ${({ windowWidth }) => (windowWidth < 410 ? '14px' : '24px')};
`
export const CalendarTodayDateButton = styled.button`
  -webkit-border-radius: 4px;
  -webkit-box-sizing: border-box;
  background-color: transparent;
  background-position: center;
  border: 1px solid #dadce0;
  border-radius: 4px;
  box-sizing: border-box;
  height: 36px;
  transition: background 0.8s;

  &:hover{
    background: #f1f3f4 radial-gradient(circle, transparent 1%, #f1f3f4 1%) center/15000%;
    cursor: pointer;
  }

  &:active{
    background-color: #d4d6d7;
    background-size: 100%;
    transition: background 0s;
  }
`

export const CalendarTodayDateButtonText = styled.p`
  color: #3c4043;
  font-family: Roboto , sans-serif;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: .25px;
  margin: 0;
  opacity: 1;
  text-transform: none;
`

export const CalendarTodayDateView = styled.button`
  -webkit-border-radius: 4px;
  -webkit-box-sizing: border-box;
  background-color: transparent;
  background-position: center;
  border: 1px solid #dadce0;
  border-radius: 4px;
  box-sizing: border-box;

  height: 36px;
  transition: background 0.8s;

  &:hover{
    background: #f1f3f4 radial-gradient(circle, transparent 1%, #f1f3f4 1%) center/15000%;
    cursor: pointer;
  }

  &:active{
    background-color: #d4d6d7;
    background-size: 100%;
    transition: background 0s;
  }
`

export const DateTimeRangePickerWrapper = styled.div`
  background: #fff;
  border-radius: 4px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  padding: 24px;
  position: absolute;
  transform: translate(-5%, 0%);
`

export const CalendarTodayDateButtonSpan = styled.span`
   color: #3c4043;
   font-family: Roboto, sans-serif;
   font-size: 14px;
   font-weight: 500;
   letter-spacing: .25px;
  opacity: 1;
  text-transform: none;
`
export const CalendarSettingsButton = styled.button`
  background: none;
  border: none;
  border-radius: 50px;
  color: #989898;
  height: 38px;
  transition: background 0.8s;
  width: 38px;

  &:hover {
    background: #f1f3f4 radial-gradient(circle, transparent 1%, #f1f3f4 1%) center/15000%;
    border-radius: 50px;
    cursor: pointer;
  }

  &:active{
    background-color: #d4d6d7;
    background-size: 100%;
    transition: background 0s;
  }

`

export const CalendarSettingsButtonIcon = styled(FontAwesomeIcon)`
  font-size: 1.2rem
`
